
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watchlist",
      function () {
        return require("private-next-pages/watchlist/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/watchlist"])
      });
    }
  